var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-row-justified"},[_c('span',{staticClass:"section-row-justified__title"},[_vm._t("title")],2),_vm._v(" "),_c('span',{staticClass:"section-row-justified__value"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }